import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import AdminLayout from '../Componets/AdminLayout';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export default function ReasseSubjectList() {
  const apiUrl = process.env.REACT_APP_API_URL;
  const navigate = useNavigate();
  const location = useLocation();
  const { id, name } = location.state || {};
  const [examDetails, setExamDetails] = useState({ name: '', subjects: [] });
  const [subjectList, setSubjectList] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');

  useEffect(() => {
    const role = localStorage.getItem('role');
    if (role !== 'ADMIN') {
      navigate('/');
    }

    const token = localStorage.getItem('token');
    const fetchExamDetails = axios.get(`${apiUrl}/api/exam/${id}`, {
      headers: {
        Authorization: ` ${token}`,
      },
    });

    const fetchSubjectList = axios.get(`${apiUrl}/api/subject`, {
      headers: {
        Authorization: ` ${token}`,
      },
    });

    Promise.all([fetchExamDetails, fetchSubjectList])
      .then(([examRes, subjectRes]) => {
        setExamDetails({
          name: examRes.data.name,
          subjects: examRes.data.subjects || [],
        });
        setSubjectList(subjectRes.data.subjects || []);
      })
      .catch((err) => {
        console.error(err);
        err.response?.status === 401 && navigate('/');
        toast.error('Failed to fetch exam details or subjects');
      });
  }, [apiUrl, id, navigate]);

  const getSubjectNameById = (subjectId) => {
    const subject = subjectList.find((sub) => sub.id === subjectId);
    return subject ? subject.name : 'Unknown';
  };

  const filteredSubjects = examDetails.subjects.filter((subject) =>
    getSubjectNameById(subject.subjectId)
      .toLowerCase()
      .includes(searchQuery.toLowerCase())
  );

  return (
    <AdminLayout ac7="active">
      <main id="main" className="main">
        <div className="exam-details-pagetitle">
          <nav>
            <ol className="breadcrumb">
              <li className="breadcrumb-item">
                <Link to="/AdminHome">Dashboard</Link>
              </li>
              <li className="breadcrumb-item">
                <span className="cursor-pointer" onClick={() => navigate(-1)}>
                  Exams for Internal Marks
                </span>
              </li>
              <li className="breadcrumb-item active">Subject List </li>
            </ol>
          </nav>
        </div>
        {/* Search Bar */}
        <div className="exam-details-search-bar d-inline-flex p-2 pb-0">
          <input
            type="text"
            placeholder="Search"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            className="form-control"
          />
        </div>

        <hr className="border border-1 border-dark" />
        <div className="exam-details-image-container ">
          {examDetails.subjects.length > 0 ? (
            <div className="exam-details-grid-container">
              {filteredSubjects.map((subject, index) => (
                <div
                  key={index}
                  className="exam-details-image-item"
                  style={{ cursor: 'pointer' }}
                >
                  <img
                    src={
                      'https://cdn-icons-png.freepik.com/512/2436/2436702.png?uid=R147462799&ga=GA1.1.549412807.1722501047'
                    } // Replace with the actual path to your images
                    alt={getSubjectNameById(subject.subjectId)}
                    onClick={() =>
                      navigate(`/ListMarks`, {
                        state: {
                          subjectId: subject.subjectId,
                          examId: id,
                          subjectName: getSubjectNameById(subject.subjectId),
                          ExamName: name,
                        },
                      })
                    }
                    style={{
                      width: '100px',
                      height: '100px',
                      objectFit: 'cover',
                    }} // Adjust styling as needed
                  />
                  <p>{getSubjectNameById(subject.subjectId)}</p>
                </div>
              ))}
            </div>
          ) : (
            <p>No subjects available</p>
          )}
        </div>

        <ToastContainer position="top-center" style={{ width: 'auto' }} />
      </main>
    </AdminLayout>
  );
}
